const applyRequestBodyVisibility = editor => {
    const method = editor.querySelector('select[name="method"]');
    const body = editor.querySelector('textarea[name="body"]');

    if (method === null || body === null) {
        return;
    }

    body.closest('label').hidden = method.value === 'GET';
};

export const initializeApiBrowser = root => {
    root.querySelectorAll?.('.api-browser-editor').forEach(applyRequestBodyVisibility);

    if (root.matches?.('.api-browser-editor')) {
        applyRequestBodyVisibility(root);
    }
};

export const handleApiBrowserMethodChange = target => {
    if (!target.matches('.api-browser-editor select[name="method"]')) {
        return;
    }

    applyRequestBodyVisibility(target.closest('.api-browser-editor'));
};
